/* Mario Games · diseño C: banner, pestañas, ficha y orden
   12-oct-2026: preventas calculadas con la hora de Ciudad de México, tarjetas con carrito
   (mini selector Secundaria/Principal), aviso flotante, barra de compra fija, compartir,
   "También te puede gustar" y "Lo que viste antes". */
(function () {
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var LARGOS = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  var CORTOS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
  var IC = {
    carro: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M2.8 4h2.4l2.2 10.3a1.7 1.7 0 0 0 1.7 1.3h8.1a1.7 1.7 0 0 0 1.6-1.3L20.6 8H6"/><circle cx="9.6" cy="19.6" r="1.4"/><circle cx="17.2" cy="19.6" r="1.4"/></svg>',
    wa: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M3.5 20.5l1.4-4.2A8.5 8.5 0 1 1 8 19.3z"/><path d="M9.2 8.6c-.2 2.9 2.4 5.6 5.4 5.7l1.1-1.3-1.8-.9-.9.7c-1.2-.4-2-1.3-2.4-2.4l.7-.9-.9-1.8z"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12l4 4L19 6"/></svg>',
    cerrar: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>'
  };
  var DATOS = window.mgDatos || {};
  var WA = DATOS.wa || '524621972391';
  var PREVENTAS = DATOS.preventas || {};

  /* ---------- utilidades ---------- */
  function lista(r, s) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function raiz() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function dinero(c) {
    var n = c / 100;
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 });
  }
  function conDiez(c) { return c - Math.round(c / 10); }
  function waURL(msg) { return 'https://wa.me/' + WA + '?text=' + encodeURIComponent(msg); }

  /* Fecha de hoy en Ciudad de México (AAAA-MM-DD), sin depender del caché de la página. */
  function hoyMX() {
    try {
      var s = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Mexico_City', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
      if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
    } catch (e) {}
    return new Date(Date.now() - 6 * 3600 * 1000).toISOString().slice(0, 10);
  }
  function aUTC(f) { var p = f.split('-'); return Date.UTC(+p[0], +p[1] - 1, +p[2]); }
  /* Regla de la tienda (12-oct): un juego es estreno desde el día que sale y durante 2 meses. */
  function finEstreno(f) {
    var p = f.split('-'), y = +p[0], m = +p[1] + 2;
    if (m > 12) { m -= 12; y += 1; }
    return y + '-' + (m < 10 ? '0' : '') + m + '-' + p[2];
  }
  function estadoFecha(f) {
    if (!f || !/^\d{4}-\d{2}-\d{2}$/.test(f)) return null;
    var hoy = hoyMX();
    var dias = Math.round((aUTC(f) - aUTC(hoy)) / 864e5);
    var p = f.split('-');
    var mes = +p[1] - 1, dia = +p[2];
    return {
      modo: dias > 0 ? 'preventa' : (hoy < finEstreno(f) ? 'estreno' : ''),
      dias: dias,
      corta: dia + ' ' + CORTOS[mes],
      larga: dia + ' de ' + LARGOS[mes]
    };
  }

  function contarCarrito(n) {
    lista(document, '[data-mg-carro-n]').forEach(function (b) {
      b.textContent = n;
      b.hidden = !n;
    });
    lista(document, '[data-mg-carro]').forEach(function (a) {
      a.setAttribute('aria-label', 'Carrito (' + n + ')');
    });
  }
  function leerCarrito() {
    return fetch(raiz() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { contarCarrito(c.item_count); return c; });
  }
  function agregarAlCarrito(id) {
    return fetch(raiz() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw new Error('add'); return leerCarrito(); });
  }

  /* Aviso flotante: "Quedó en tu carrito · Ver carrito", "Enlace copiado"… */
  var aviso = null, avisoReloj = null;
  function avisar(texto, conCarrito) {
    if (!aviso) {
      aviso = document.createElement('div');
      aviso.className = 'mg-aviso-flot';
      aviso.setAttribute('role', 'status');
      aviso.setAttribute('aria-live', 'polite');
      document.body.appendChild(aviso);
    }
    aviso.innerHTML = IC.check + '<span>' + esc(texto) + '</span>' + (conCarrito ? '<a href="' + raiz() + 'cart">Ver carrito</a>' : '');
    aviso.classList.remove('on');
    void aviso.offsetWidth;
    aviso.classList.add('on');
    clearTimeout(avisoReloj);
    avisoReloj = setTimeout(function () { aviso.classList.remove('on'); }, conCarrito ? 5200 : 2800);
  }

  function copiar(t) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(t);
    return new Promise(function (ok, mal) {
      var a = document.createElement('textarea');
      a.value = t;
      a.setAttribute('readonly', '');
      a.style.position = 'fixed';
      a.style.opacity = '0';
      document.body.appendChild(a);
      a.select();
      var hecho = false;
      try { hecho = document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(a);
      if (hecho) ok(); else mal();
    });
  }

  /* ---------- banner ---------- */
  function iniciarBanner(root) {
    if (root.dataset.mgListo) return;
    root.dataset.mgListo = '1';
    var slides = lista(root, '.sl');
    var pests = lista(root, '.pest');
    var ms = parseInt(root.dataset.intervalo, 10) || 5200;
    root.style.setProperty('--mg-dur', ms + 'ms');
    var i = 0;
    var reloj = null;
    var pausa = reducido || slides.length < 2;
    var boton = root.querySelector('[data-mg-pausa]');

    function marcarPausa() {
      root.classList.toggle('pausa', pausa);
      if (boton) {
        boton.setAttribute('aria-label', pausa ? 'Reanudar' : 'Pausar');
        boton.setAttribute('aria-pressed', pausa ? 'true' : 'false');
      }
    }
    function programar() {
      clearInterval(reloj);
      if (!pausa && !document.hidden) {
        reloj = setInterval(function () { mostrar(i + 1); }, ms);
      }
    }
    function mostrar(n) {
      if (!slides.length) return;
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === i;
        s.classList.toggle('on', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        if ('inert' in s) s.inert = !on;
      });
      pests.forEach(function (p, k) {
        var on = k === i;
        p.classList.remove('on');
        if (on) { void p.offsetWidth; p.classList.add('on'); }
        p.setAttribute('aria-current', on ? 'true' : 'false');
      });
      programar();
    }
    var prev = root.querySelector('[data-mg-prev]');
    var next = root.querySelector('[data-mg-next]');
    if (prev) prev.addEventListener('click', function () { mostrar(i - 1); });
    if (next) next.addEventListener('click', function () { mostrar(i + 1); });
    if (boton) boton.addEventListener('click', function () { pausa = !pausa; marcarPausa(); programar(); });
    pests.forEach(function (p, k) { p.addEventListener('click', function () { mostrar(k); }); });
    document.addEventListener('visibilitychange', programar);
    root.addEventListener('shopify:block:select', function (e) {
      var k = slides.indexOf(e.target.closest ? e.target.closest('.sl') : null);
      if (k > -1) { pausa = true; marcarPausa(); mostrar(k); }
    });
    marcarPausa();
    mostrar(0);
  }

  function iniciarFiltro(sec) {
    if (sec.dataset.mgListo) return;
    sec.dataset.mgListo = '1';
    var tabs = lista(sec, '[data-filtro]');
    var cards = lista(sec, '[data-compat]');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var f = t.dataset.filtro;
        tabs.forEach(function (x) {
          var on = x === t;
          x.classList.toggle('on', on);
          x.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        cards.forEach(function (c) { c.hidden = !(f === 'todos' || c.dataset.compat === f); });
      });
    });
  }

  /* ---------- tarjetas ---------- */
  function leerVars(card) {
    try { var v = JSON.parse(card.dataset.vars || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }
  function msgTarjeta(card, v, apartar) {
    var saludo = apartar ? 'Hola, quiero apartar ' : 'Hola, me interesa ';
    var t = card.dataset.titulo || '';
    if (card.dataset.sinOp === '1' || !v.op) return saludo + t + ' (' + dinero(v.p) + ').';
    return saludo + t + ' en ' + v.op.toLowerCase() + ' (' + dinero(v.p) + ').' + (card.dataset.diez === 'false' ? '' : ' Lo pido desde la página con el 10% de descuento.');
  }
  function iniciarTarjeta(card) {
    if (card.dataset.mgListo) return;
    card.dataset.mgListo = '1';
    var e = estadoFecha(card.dataset.fecha);
    var modo = e ? e.modo : '';
    card.dataset.modo = modo;
    var cinta = card.querySelector('[data-mg-cinta]');
    if (cinta) {
      cinta.hidden = !modo;
      cinta.classList.toggle('est', modo === 'estreno');
      if (modo) cinta.textContent = modo === 'preventa' ? 'Preventa · ' + e.corta : 'Estreno';
    }
    if (card.dataset.fecha) {
      var apartar = modo === 'preventa';
      var txt = card.querySelector('[data-mg-agr-txt]');
      if (txt) txt.textContent = apartar ? 'Apartar' : 'Agregar';
      var agr = card.querySelector('[data-mg-agregar]');
      if (agr) agr.setAttribute('aria-label', (apartar ? 'Apartar ' : 'Agregar ') + (card.dataset.titulo || '') + ' al carrito');
      var v = leerVars(card)[0];
      var pedir = card.querySelector('[data-mg-pedir]');
      if (pedir && v) pedir.href = waURL(msgTarjeta(card, v, apartar));
    }
    if (card.closest('[data-mg-preventas]') && card.dataset.fecha && modo !== 'preventa') card.hidden = true;
  }
  function revisarPreventas(sec) {
    var hay = lista(sec, '[data-mg-card]').some(function (c) { return !c.hidden; });
    var vacio = sec.querySelector('[data-mg-pre-vacio]');
    if (vacio) vacio.hidden = hay;
  }
  function cerrarElige(card) {
    var p = card && card.querySelector('.elige');
    if (p) p.parentNode.removeChild(p);
  }
  function abrirElige(card, vars) {
    lista(document, '.cc .elige').forEach(function (p) { p.parentNode.removeChild(p); });
    var div = document.createElement('div');
    div.className = 'elige';
    div.setAttribute('role', 'group');
    div.setAttribute('aria-label', 'Elige cómo lo quieres');
    div.innerHTML = '<p>¿Cómo lo quieres?</p>' + vars.map(function (v) {
      return '<button type="button" class="op-b" data-mg-op-v="' + esc(v.id) + '"><span>' + esc(v.op) + '</span><b>' + dinero(v.p) + '</b></button>';
    }).join('') + '<button type="button" class="x" data-mg-elige-x aria-label="Cerrar">' + IC.cerrar + '</button>';
    card.appendChild(div);
    div.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        cerrarElige(card);
        var b = card.querySelector('[data-mg-agregar]');
        if (b) b.focus();
      }
    });
    var primero = div.querySelector('.op-b');
    if (primero) primero.focus({ preventScroll: true });
  }
  function agregarDesdeTarjeta(card, boton, v) {
    if (!v || boton.getAttribute('aria-busy') === 'true') return;
    boton.setAttribute('aria-busy', 'true');
    agregarAlCarrito(v.id).then(function () {
      boton.removeAttribute('aria-busy');
      cerrarElige(card);
      var agr = card.querySelector('[data-mg-agregar]');
      if (agr) {
        agr.classList.add('ok');
        setTimeout(function () { agr.classList.remove('ok'); }, 1800);
      }
      avisar('Quedó en tu carrito', true);
    }).catch(function () {
      boton.removeAttribute('aria-busy');
      avisar('No se pudo agregar. Inténtalo otra vez o pídelo por WhatsApp.', false);
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var b = t.closest('[data-mg-agregar]');
    if (b) {
      var card = b.closest('[data-mg-card]');
      if (!card) return;
      e.preventDefault();
      var vars = leerVars(card);
      if (vars.length > 1) abrirElige(card, vars);
      else if (vars.length === 1) agregarDesdeTarjeta(card, b, vars[0]);
      return;
    }
    var o = t.closest('[data-mg-op-v]');
    if (o) {
      var card2 = o.closest('[data-mg-card]');
      var v = leerVars(card2).filter(function (x) { return String(x.id) === o.getAttribute('data-mg-op-v'); })[0];
      agregarDesdeTarjeta(card2, o, v);
      return;
    }
    if (t.closest('[data-mg-elige-x]')) {
      cerrarElige(t.closest('[data-mg-card]'));
      return;
    }
    if (!t.closest('.elige')) lista(document, '.cc .elige').forEach(function (p) { p.parentNode.removeChild(p); });
  });

  /* Tarjeta armada en el navegador (recomendaciones y vistos), igual a snippets/mg-tarjeta. */
  function tamano(u, w) {
    if (!u) return '';
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function tarjetaHTML(d) {
    var vars = (d.vars || []).slice().sort(function (a, b) { return a.p - b.p; });
    var v = vars[0];
    if (!v) return '';
    var e = estadoFecha(d.f);
    var modo = e ? e.modo : '';
    var apartar = modo === 'preventa';
    var et = d.e || v.op || '';
    var cartaTmp = { dataset: { titulo: d.t, sinOp: d.s ? '1' : '', diez: d.d === false ? 'false' : 'true' } };
    var url = d.u || ('/products/' + d.h);
    var foto = d.i
      ? '<span class="cvw' + (d.k === 'paq' ? ' paq' : '') + '"><img src="' + esc(d.i) + '" alt="' + esc(d.t) + '" loading="lazy" width="240" height="' + (d.k === 'paq' ? 240 : 320) + '"></span>'
      : '<span class="tele"><b>' + esc(d.t) + '</b><span>' + esc(et) + '</span></span>';
    return '<article class="cc" data-mg-card data-titulo="' + esc(d.t) + '" data-diez="' + (d.d === false ? 'false' : 'true') + '" data-sin-op="' + (d.s ? '1' : '') + '" data-vars="' + esc(JSON.stringify(vars)) + '"' + (d.f ? ' data-fecha="' + esc(d.f) + '"' : '') + '>' +
      '<a class="marco" href="' + esc(url) + '" aria-label="' + esc(d.t) + '">' +
        (d.f ? '<span class="cinta' + (modo === 'estreno' ? ' est' : '') + '" data-mg-cinta' + (modo ? '' : ' hidden') + '>' + (modo === 'estreno' ? 'Estreno' : (e ? 'Preventa · ' + e.corta : '')) + '</span>' : '') +
        (d.c ? '<span class="compat ' + esc(d.cc || 'sw1') + '">' + esc(d.c) + '</span>' : '') +
        '<span class="base-hex" aria-hidden="true"></span>' + foto +
      '</a>' +
      '<div class="cb">' +
        '<h3 class="cb-t"><a href="' + esc(url) + '">' + esc(d.t) + '</a></h3>' +
        '<div class="pr"><span><small>' + esc(et) + '</small><span class="v">' + dinero(v.p) + '</span></span></div>' +
        '<div class="acc">' +
          '<button type="button" class="agr" data-mg-agregar aria-label="' + (apartar ? 'Apartar ' : 'Agregar ') + esc(d.t) + ' al carrito">' + IC.carro + '<span data-mg-agr-txt>' + (apartar ? 'Apartar' : 'Agregar') + '</span></button>' +
          '<a class="pedir" data-mg-pedir href="' + esc(waURL(msgTarjeta(cartaTmp, v, apartar))) + '" target="_blank" rel="noopener" aria-label="Pedir ' + esc(d.t) + ' por WhatsApp">' + IC.wa + '<span>Pedir</span></a>' +
        '</div>' +
      '</div>' +
    '</article>';
  }
  function compatDe(tags, paq, serv) {
    if (paq) return ['Paquete', 'mej'];
    if (serv) return ['Streaming', 'sw1'];
    var orden = [['Solo Switch 2', 'sw2'], ['Mejorado en Switch 2', 'mej'], ['Switch 1 y 2', 'sw1'], ['PS4 y PS5', 'sw1'], ['Solo PS5', 'sw1'], ['Xbox One y Series X|S', 'sw1'], ['Solo Series X|S', 'sw1']];
    for (var i = 0; i < orden.length; i++) if (tags.indexOf(orden[i][0]) > -1) return orden[i];
    return ['', 'sw1'];
  }
  /* Producto de /recommendations/products.json → datos de tarjeta */
  function deJSON(p) {
    if (!p || !p.variants || !p.variants.length) return null;
    var nombresOp = (p.options || []).map(function (o) { return typeof o === 'string' ? o : (o && o.name); });
    var tipo = nombresOp.indexOf('Tipo') > -1;
    var serv = p.type === 'Servicio', paq = p.type === 'Paquete';
    var fija = serv ? '' : (paq ? '' : (p.vendor === 'PlayStation' ? 'Principal' : 'Secundaria'));
    var vars = p.variants.map(function (v) {
      return { id: v.id, op: tipo ? (v.option1 || '') : fija, p: v.price };
    });
    var tags = p.tags || [];
    var c = compatDe(tags, paq, serv);
    var img = p.featured_image;
    if (img && typeof img === 'object') img = img.url || img.src || '';
    return {
      h: p.handle, u: p.url || ('/products/' + p.handle), t: p.title, i: tamano(img || '', 360),
      c: c[0], cc: c[1], f: PREVENTAS[p.handle] || '', d: !(serv || paq), s: serv || paq,
      k: paq ? 'paq' : '', e: serv ? String(p.title).split('· ').pop() : (paq ? 'Secundaria' : ''), vars: vars
    };
  }

  /* ---------- ficha ---------- */
  var CLAVE_VISTOS = 'mg-vistos';
  function leerVistos() {
    try {
      var a = JSON.parse(window.localStorage.getItem(CLAVE_VISTOS) || '[]');
      return Array.isArray(a) ? a : [];
    } catch (e) { return []; }
  }
  function guardarVisto(d) {
    try {
      var a = leerVistos().filter(function (x) { return x && x.h && x.h !== d.h; });
      a.unshift(d);
      window.localStorage.setItem(CLAVE_VISTOS, JSON.stringify(a.slice(0, 9)));
    } catch (e) {}
  }
  function llenarFila(sec, html) {
    var fila = sec.querySelector('[data-mg-fila]');
    if (!fila || !html) return;
    fila.innerHTML = html;
    sec.hidden = false;
    lista(fila, '[data-mg-card]').forEach(iniciarTarjeta);
  }
  /* Consolas que sirven para la del juego que se está viendo (Switch 2 también corre juegos de Switch). */
  function consolasPara(vendor) {
    if (vendor === 'Nintendo Switch 2') return ['Nintendo Switch 2', 'Nintendo Switch'];
    return vendor ? [vendor] : [];
  }
  function handleDe(card) {
    var a = card.querySelector('a[href*="/products/"]');
    return a ? a.getAttribute('href').split('/products/').pop().split(/[?#]/)[0] : '';
  }
  /* La tienda ya pone juegos de la misma saga; aquí se completa con las recomendaciones de Shopify
     que sirvan en la misma consola, sin repetir. */
  function cargarRecos(sec, actual, vendor) {
    var pid = sec.dataset.pid;
    var fila = sec.querySelector('[data-mg-fila]');
    if (!pid || !fila || !window.fetch) return;
    var ya = lista(fila, '[data-mg-card]');
    if (ya.length >= 8) return;
    var sirven = consolasPara(vendor);
    var usados = {};
    usados[actual] = 1;
    ya.forEach(function (c) { usados[handleDe(c)] = 1; usados[String(c.dataset.titulo || '').toLowerCase()] = 1; });
    var ir = function () {
      fetch(raiz() + 'recommendations/products.json?product_id=' + encodeURIComponent(pid) + '&limit=10', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('recos'); return r.json(); })
        .then(function (j) {
          var nuevos = ((j && j.products) || []).filter(function (p) {
            if (!p || p.available === false || usados[p.handle]) return false;
            if (sirven.length && sirven.indexOf(p.vendor) < 0) return false;
            var t = String(p.title).toLowerCase();
            if (usados[t]) return false;
            usados[p.handle] = 1;
            usados[t] = 1;
            return true;
          }).slice(0, 8 - ya.length);
          if (ya.length + nuevos.length < 2) return;
          if (nuevos.length) {
            var tmp = document.createElement('div');
            tmp.innerHTML = nuevos.map(deJSON).filter(Boolean).map(tarjetaHTML).join('');
            lista(tmp, '[data-mg-card]').forEach(function (c) { fila.appendChild(c); iniciarTarjeta(c); });
          }
          sec.hidden = false;
        })
        .catch(function () {});
    };
    if ('requestIdleCallback' in window) window.requestIdleCallback(ir, { timeout: 2500 });
    else setTimeout(ir, 900);
  }

  function iniciarFicha(f) {
    if (f.dataset.mgListo) return;
    f.dataset.mgListo = '1';
    var nodo = f.querySelector('[data-mg-datos]');
    if (!nodo) return;
    var datos;
    try { datos = JSON.parse(nodo.textContent); } catch (e) { return; }
    var q = function (s) { return f.querySelector(s); };
    var el = {
      lab: q('[data-mg-lab]'), precio: q('[data-mg-precio]'), der: q('[data-mg-der]'),
      ahorro: q('[data-mg-ahorro]'), sello: q('[data-mg-sello]'), selloTxt: q('[data-mg-sello-txt]'),
      wa: q('[data-mg-wa]'), waTxt: q('[data-mg-watxt]'),
      diez: q('[data-mg-diez]'), tres: q('[data-mg-tres]'),
      vid: q('[data-mg-vid]'), comTxt: q('[data-mg-comtxt]'), form: q('[data-mg-comprar]'),
      listo: q('[data-mg-agregado]'), nota: q('[data-mg-nota]'),
      preChip: q('[data-mg-pre-chip]'), pre: q('[data-mg-pre]'), preN: q('[data-mg-pre-n]'),
      preU: q('[data-mg-pre-u]'), faltan: q('[data-mg-faltan]'), preFecha: q('[data-mg-pre-fecha]'),
      barra: q('[data-mg-barra]'), barraPrecio: q('[data-mg-barra-precio]'), barraOp: q('[data-mg-barra-op]'),
      barraTxt: q('[data-mg-barra-txt]'), barraWa: q('[data-mg-barra-wa]'), barraAgr: q('[data-mg-barra-agregar]'),
      compartir: q('[data-mg-compartir]')
    };
    var promo = datos.promo || {};
    var est = estadoFecha(datos.fecha);
    var modo = est ? est.modo : '';
    var apartar = modo === 'preventa';

    if (el.preChip) {
      el.preChip.hidden = !modo;
      el.preChip.classList.toggle('est', modo === 'estreno');
      if (modo) el.preChip.textContent = apartar ? 'Preventa · sale el ' + est.larga : 'Estreno';
    }
    if (el.pre) {
      el.pre.hidden = !apartar;
      if (apartar) {
        if (el.preN) el.preN.textContent = est.dias;
        if (el.preU) el.preU.textContent = est.dias === 1 ? 'día' : 'días';
        if (el.faltan) el.faltan.textContent = est.dias === 1 ? 'Falta 1 día' : 'Faltan ' + est.dias + ' días';
        if (el.preFecha) el.preFecha.textContent = est.larga;
      }
    }
    if (el.nota) {
      el.nota.textContent = apartar
        ? 'Paga aquí en la página. Se entrega el día del estreno, por WhatsApp de 10:00 a 21:00.'
        : 'Paga aquí en la página. Te entregamos por WhatsApp de 10:00 a 21:00.';
    }
    if (el.barraTxt) el.barraTxt.textContent = apartar ? 'Apartar' : 'Agregar';
    if (el.form) {
      var botonComprar = el.form.querySelector('.pedir-g');
      if (botonComprar) botonComprar.classList.toggle('pre', apartar);
    }

    function aplicar(v) {
      if (!v) return;
      if (el.lab) el.lab.textContent = v.op || datos.etiqueta;
      if (el.precio) el.precio.textContent = dinero(v.precio);
      var hay = datos.eshop > v.precio;
      if (el.der) el.der.hidden = !hay;
      if (el.sello) el.sello.hidden = !hay;
      if (hay) {
        if (el.ahorro) el.ahorro.textContent = 'Ahorras ' + dinero(datos.eshop - v.precio);
        if (el.selloTxt) el.selloTxt.textContent = '-' + (100 - Math.round(v.precio * 100 / datos.eshop)) + '%';
      }
      var opcion = v.op ? ' en ' + v.op.toLowerCase() : '';
      if (el.diez) el.diez.textContent = dinero(conDiez(v.precio));
      if (el.tres) {
        var op = v.op || datos.etiqueta;
        el.tres.hidden = !(!promo.ex && (promo.xb || (promo.sw && op === 'Secundaria')));
      }
      var msg = (apartar ? 'Hola, quiero apartar ' : 'Hola, me interesa ') + datos.titulo + opcion + ' (' + dinero(v.precio) + ').' + (promo.diez === false ? '' : ' Lo pido desde la página con el 10% de descuento.');
      var href = 'https://wa.me/' + datos.wa + '?text=' + encodeURIComponent(msg);
      var verboWa = apartar ? 'Apartar' : 'Pedir';
      var verbo = apartar ? 'Apartar' : 'Comprar';
      if (el.wa) el.wa.href = href;
      if (el.barraWa) {
        el.barraWa.href = href;
        el.barraWa.setAttribute('aria-label', (v.op ? verboWa + ' ' + v.op.toLowerCase() : verboWa) + ' por WhatsApp');
      }
      if (el.waTxt) el.waTxt.textContent = v.op ? verboWa + ' ' + v.op.toLowerCase() : verboWa;
      if (el.vid) el.vid.value = v.id;
      if (el.comTxt) el.comTxt.innerHTML = esc(verbo) + (v.op ? '<span class="op"> ' + esc(v.op.toLowerCase()) + '</span>' : '');
      if (el.barraPrecio) el.barraPrecio.textContent = dinero(v.precio);
      if (el.barraOp) el.barraOp.textContent = v.op || datos.etiqueta;
      if (el.listo) el.listo.hidden = true;
    }
    var actual = datos.variantes.filter(function (x) { return el.vid && String(x.id) === el.vid.value; })[0] || datos.variantes[0];
    aplicar(actual);

    var enviando = false;
    var boton = el.form ? el.form.querySelector('button[type="submit"]') : null;
    function enviar(desdeBarra) {
      if (enviando || !el.form) return;
      enviando = true;
      if (boton) boton.setAttribute('aria-busy', 'true');
      if (el.barraAgr) el.barraAgr.setAttribute('aria-busy', 'true');
      fetch(raiz() + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(el.form) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return leerCarrito(); })
        .then(function () {
          enviando = false;
          if (boton) boton.removeAttribute('aria-busy');
          if (el.barraAgr) el.barraAgr.removeAttribute('aria-busy');
          if (desdeBarra) {
            avisar('Quedó en tu carrito', true);
          } else if (el.listo) {
            el.listo.hidden = false;
            var ir = el.listo.querySelector('a');
            if (ir) ir.focus({ preventScroll: true });
          }
        })
        .catch(function () {
          enviando = false;
          if (boton) boton.removeAttribute('aria-busy');
          if (el.barraAgr) el.barraAgr.removeAttribute('aria-busy');
          HTMLFormElement.prototype.submit.call(el.form);
        });
    }
    if (el.form && window.fetch && window.FormData) {
      var seguir = el.form.querySelector('[data-mg-seguir]');
      if (seguir) seguir.addEventListener('click', function () { if (el.listo) el.listo.hidden = true; });
      el.form.addEventListener('submit', function (e) {
        e.preventDefault();
        enviar(false);
      });
      if (el.barraAgr) el.barraAgr.addEventListener('click', function () { enviar(true); });
    }
    lista(f, 'input[name="mg-opcion"]').forEach(function (r) {
      r.addEventListener('change', function () {
        lista(f, '.op').forEach(function (o) {
          o.classList.toggle('on', o.contains(r) && r.checked);
        });
        var v = datos.variantes.filter(function (x) { return String(x.id) === r.value; })[0];
        aplicar(v);
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', r.value);
          window.history.replaceState({}, '', u.toString());
        } catch (e) {}
      });
    });

    /* Barra fija: aparece cuando el botón de comprar ya quedó arriba. */
    if (el.barra && boton && 'IntersectionObserver' in window) {
      var raizDoc = document.documentElement;
      new IntersectionObserver(function (es) {
        var e = es[es.length - 1];
        var mostrar = !e.isIntersecting && e.boundingClientRect.top < 0;
        el.barra.classList.toggle('on', mostrar);
        el.barra.setAttribute('aria-hidden', mostrar ? 'false' : 'true');
        el.barra.inert = !mostrar;
        raizDoc.classList.toggle('mg-barra-on', mostrar);
      }).observe(boton);
    }

    /* Compartir: menú del teléfono o copiar el enlace. */
    if (el.compartir) {
      el.compartir.addEventListener('click', function () {
        var canon = document.querySelector('link[rel="canonical"]');
        var url = (canon && canon.href) || window.location.href.split('?')[0];
        if (navigator.share) {
          navigator.share({ title: datos.titulo, text: datos.titulo + ' en Mario Games', url: url }).catch(function () {});
          return;
        }
        copiar(url).then(function () {
          avisar('Enlace copiado. Pégalo donde quieras.', false);
        }, function () {
          window.prompt('Copia el enlace:', url);
        });
      });
    }

    /* También te puede gustar + Lo que viste antes */
    var recos = q('[data-mg-recos]');
    if (recos) cargarRecos(recos, datos.handle, datos.vendor);
    var vistos = q('[data-mg-vistos]');
    if (vistos) {
      var antes = leerVistos().filter(function (x) { return x && x.h && x.h !== datos.handle && x.vars && x.vars.length; }).slice(0, 8);
      if (antes.length) llenarFila(vistos, antes.map(tarjetaHTML).join(''));
    }
    guardarVisto({
      h: datos.handle, u: datos.url, t: datos.titulo, i: datos.img, c: datos.compat, cc: datos.compatCls,
      f: datos.fecha || '', d: promo.diez !== false, s: !!datos.sinOp, k: datos.paq ? 'paq' : '',
      e: datos.sinOp ? datos.etiqueta : '',
      vars: datos.variantes.map(function (v) { return { id: v.id, op: v.op, p: v.precio }; })
    });

    var esc3d = q('.escena');
    if (esc3d && !reducido && window.matchMedia('(hover: hover)').matches) {
      var raf = 0, nx = 0.5, ny = 0.5;
      esc3d.addEventListener('pointermove', function (e) {
        var r = esc3d.getBoundingClientRect();
        nx = (e.clientX - r.left) / r.width;
        ny = (e.clientY - r.top) / r.height;
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          esc3d.style.setProperty('--rx', ((0.5 - ny) * 16).toFixed(1) + 'deg');
          esc3d.style.setProperty('--ry', ((nx - 0.5) * 22).toFixed(1) + 'deg');
          esc3d.style.setProperty('--bx', Math.round(100 - nx * 100) + '%');
        });
      });
      esc3d.addEventListener('pointerleave', function () {
        esc3d.style.setProperty('--rx', '0deg');
        esc3d.style.setProperty('--ry', '0deg');
        esc3d.style.setProperty('--bx', '50%');
      });
    }
  }

  /* ---------- carrito ---------- */
  function iniciarCarrito(c) {
    if (c.dataset.mgListo) return;
    c.dataset.mgListo = '1';
    lista(c, '[data-mg-cart-fecha]').forEach(function (s) {
      var e = estadoFecha(s.getAttribute('data-mg-cart-fecha'));
      s.hidden = !(e && e.modo === 'preventa');
      if (e && e.modo === 'preventa') s.textContent = 'Preventa · sale el ' + e.larga;
    });
    var nodo = c.querySelector('[data-mg-carrito-datos]');
    if (!nodo) return;
    var d;
    try { d = JSON.parse(nodo.textContent); } catch (e) { return; }
    var unidades = [];
    (d.items || []).forEach(function (it) {
      if (it.t) for (var k = 0; k < it.q; k++) unidades.push(it.precio);
    });
    var caja = c.querySelector('[data-mg-tres3]');
    var txt = c.querySelector('[data-mg-tres3-txt]');
    if (unidades.length < 3 || !caja || !txt) return;
    unidades.sort(function (a, b) { return b - a; });
    var gratis = 0;
    for (var i = 2; i < unidades.length; i += 3) gratis += unidades[i];
    var n = Math.floor(unidades.length / 3);
    var regalo = n > 1 ? n + ' de regalo' : '1 de regalo';
    if (gratis > (d.desc || 0)) {
      txt.textContent = 'Con el 3x2 ahorras ' + dinero(gratis) + ' (' + regalo + '), más que con el 10% (' + dinero(d.desc || 0) + ').';
      caja.classList.add('gana');
      var otra = c.querySelector('.otra');
      if (otra) otra.classList.add('gana');
      var wa = c.querySelector('[data-mg-wa-carrito]');
      if (wa && d.wa) wa.href = 'https://wa.me/' + d.wa + '?text=' + encodeURIComponent(d.msg + '\nQuiero el 3x2: me queda en ' + dinero((d.normal || 0) - gratis) + ' (' + regalo + ').');
    } else {
      txt.textContent = 'También te toca el 3x2 (ahorras ' + dinero(gratis) + '), pero pagando aquí con el 10% ahorras más (' + dinero(d.desc || 0) + ').';
    }
    caja.hidden = false;
  }

  function iniciarOrden(s) {
    if (s.dataset.mgListo) return;
    s.dataset.mgListo = '1';
    s.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', s.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  }

  function iniciar(base) {
    var r = base || document;
    lista(r, '[data-mg-slider]').forEach(iniciarBanner);
    lista(r, '[data-mg-filtro]').forEach(iniciarFiltro);
    lista(r, '[data-mg-card]').forEach(iniciarTarjeta);
    lista(r, '[data-mg-preventas]').forEach(revisarPreventas);
    lista(r, '[data-mg-ficha]').forEach(iniciarFicha);
    lista(r, '[data-mg-orden]').forEach(iniciarOrden);
    lista(r, '[data-mg-carrito]').forEach(iniciarCarrito);
  }

  window.MG = {
    dinero: dinero, estadoFecha: estadoFecha, hoyMX: hoyMX, avisar: avisar,
    agregarAlCarrito: agregarAlCarrito, contarCarrito: contarCarrito, raiz: raiz, esc: esc, wa: WA, preventas: PREVENTAS
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { iniciar(); });
  else iniciar();
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted || !window.fetch) return;
    leerCarrito().catch(function () {});
  });
})();
